import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userList: [],
  userDetail: [],
  dashboardData: [],
  dashboardDataMore: [],
  dashboardDataTask: [],
  dashboardDataReward: [],
  dashboardDataBestSale: [],
  dashboardDataPerMonth: [],
  dashboardDataProduct: [],
  loading: false,
  error: undefined,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchUserList(state, action) {
      state.userList = action.payload;
      state.loading = false;
    },
    fetchUserDetail(state, action) {
      state.userDetail = action.payload;
      state.loading = false;
    },
    fetchDashboarData(state, action) {
      state.dashboardData = action.payload;
      state.loading = false;
    },
    fetchDashboarDataMore(state, action) {
      state.dashboardDataMore = action.payload;
      state.loading = false;
    },
    fetchDashboarDataTask(state, action) {
      state.dashboardDataTask = action.payload;
      state.loading = false;
    },
    fetchDashboarDataReward(state, action) {
      state.dashboardDataReward = action.payload;
      state.loading = false;
    },
    fetchDashboarDataProduct(state, action) {
      state.dashboardDataProduct = action.payload;
      state.loading = false;
    },
    fetchDashboarDataBestSale(state, action) {
      state.dashboardDataBestSale = action.payload;
      state.loading = false;
    },
    fetchDashboarDataPerMonth(state, action) {
      state.dashboardDataPerMonth = action.payload;
      state.loading = false;
    },
  },
});

export const userActions = userSlice.actions;

export default userSlice.reducer;
